import * as React from 'react';
import {
  FieldProps as FinalFormFieldProps,
  FieldRenderProps as FinalFormFieldRenderProps,
  Field as FinalFormField,
} from 'react-final-form';

type FieldError = string;

export type FieldRenderProps = {
  input: FinalFormFieldRenderProps<HTMLElement>['input'];
  meta: FinalFormFieldRenderProps<HTMLElement>['meta'] & {
    /**
     * The relevant field error to display considering formState
     */
    displayError: FieldError | null | undefined;
  };
};

/**
 * Given FieldRenderProps which, if any, error should we display inline?
 */
function fieldRPToError({
  meta: {touched, error, submitError, submitFailed, dirtySinceLastSubmit},
}: FinalFormFieldRenderProps<HTMLElement>): FieldError | null | undefined {
  if ((touched || submitFailed) && error) {
    return error;
  }

  if (submitFailed && !dirtySinceLastSubmit && submitError) {
    return submitError;
  }
}

interface FieldProps
  extends Omit<FinalFormFieldProps<HTMLElement>, 'children'> {
  children: (arg0: FieldRenderProps) => React.ReactNode;
}

/**
 * Our own, slightly enhanced Field component
 * Use in place of react-final-form Field for consistent behavior
 */
export const Field: React.FC<FieldProps> = ({children, ...otherProps}) => (
  <FinalFormField {...otherProps}>
    {/* @ts-ignore */}
    {(fieldRP: FieldRenderProps): React.ReactNode => {
      const displayError = fieldRPToError(fieldRP);
      return children({
        input: fieldRP.input,
        meta: {
          ...fieldRP.meta,
          displayError,
        },
      });
    }}
  </FinalFormField>
);
